import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "regenerator-runtime/runtime.js";
import Head from "@/components/Head/index.vue";
import Tabs from "@/components/Tabs/index.vue";
import Pagination from "@/components/Pagination/index.vue";
import { defineComponent, onMounted, reactive, ref } from "vue";
import QuestionCard from "@/components/QuestionCard/index.vue"; //考试组件

import { useRoute, useRouter } from "vue-router";
import useCurrentInstance from "@/hooks/useCurrentInstance";
import { ElMessage } from "element-plus";
import 'element-plus/es/components/message/style/index'

import { validStEnpty } from "@/hooks/validate";
import { useStore } from "vuex";
export default defineComponent({
  name: "ExamBeforeDetail",
  components: {
    Tabs: Tabs,
    Head: Head,
    Pagination: Pagination,
    QuestionCard: QuestionCard
  },
  setup: function setup() {
    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties;

    var route = useRoute();
    var router = useRouter();
    var store = useStore();
    var Data = reactive({
      tipsData: [{
        label: "考试总分",
        value: "40",
        unit: "分",
        english: "fullScore",
        url: require("../../assets/img/exam/img-1.png")
      }, {
        label: "及格分数",
        value: "20",
        unit: "分",
        english: "passScore",
        url: require("../../assets/img/exam/img-2.png")
      }, {
        label: "考试时间",
        value: "60",
        unit: "分钟",
        english: "duration",
        url: require("../../assets/img/exam/img-3.png")
      }, {
        label: "总题数",
        value: "4",
        unit: "题",
        english: "allNumber",
        url: require("../../assets/img/exam/img-4.png")
      }],
      scoreData: [{
        label: "我的得分",
        value: "40",
        english: "score",
        url: require("../../assets/img/exam/img-5.png")
      }, {
        label: "是否及格",
        value: "及格",
        english: "my_pass",
        url: require("../../assets/img/exam/img-6.png")
      }, {
        label: "交卷时间",
        value: "2021-10-11 15:11:49",
        english: "handinTime",
        url: require("../../assets/img/exam/img-7.png")
      }],
      state: String(route.query.state),
      examData: {},
      dialogHeart: false,
      heartContent: ""
    });
    onMounted(function () {
      getExamDetail();
    });

    var contentPass = function contentPass(rule, value, callback) {
      if (!validStEnpty(Data.heartContent)) {
        callback(new Error("请输入内容"));
      } else {
        callback();
      }
    }; // 填写心得


    var HeartFormRef = ref(null);

    var handleAddHeart = function handleAddHeart() {
      if (HeartFormRef.value) {
        HeartFormRef.value.validate( /*#__PURE__*/function () {
          var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(valid) {
            var res;
            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    if (!valid) {
                      _context.next = 7;
                      break;
                    }

                    _context.next = 3;
                    return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["IntegratedExamHistorAddHeart"]({
                      historyId: route.query.historyId,
                      tips: Data.heartContent
                    });

                  case 3:
                    res = _context.sent;

                    if (res.code == 0) {
                      ElMessage.success("\u63D0\u4EA4\u6210\u529F");
                      Data.dialogHeart = false;
                      getExamDetail();
                    } else {
                      ElMessage.success("\u63D0\u4EA4\u6210\u529F");
                    }

                    _context.next = 8;
                    break;

                  case 7:
                    return _context.abrupt("return", false);

                  case 8:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }());
      }
    };

    function ranking() {
      router.push({
        path: "/personal/Ranking",
        query: {
          historyId: Number(Data.examData.paperId),
          state: Data.state,
          title: Data.examData.title
        }
      });
    } // 查看详情 / 开始考试


    var handleButton = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var examState;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(Data.examData.device == 2)) {
                  _context2.next = 3;
                  break;
                }

                ElMessage.error("\u8BF7\u5230\u79FB\u52A8\u7AEF\u8FDB\u884C\u7B54\u9898");
                return _context2.abrupt("return");

              case 3:
                _context2.next = 5;
                return isExamStart();

              case 5:
                examState = _context2.sent;

                if (examState) {
                  _context2.next = 8;
                  break;
                }

                return _context2.abrupt("return");

              case 8:
                router.push({
                  path: "/personal/ExamDetail",
                  query: {
                    historyId: route.query.historyId,
                    state: Data.state,
                    title: Data.examData.title
                  }
                });

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function handleButton() {
        return _ref2.apply(this, arguments);
      };
    }(); // 获取考试试题详情


    var getExamDetail = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var res, _i, _Object$keys, v, questionArr, number, _i2, _questionArr, vv;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["IntegratedExamHistory"]({
                  historyId: route.query.historyId
                });

              case 2:
                res = _context3.sent;

                // 判断code是0时为开始考试其他为详情
                if (res.data.code != 0) {
                  Data.state = "detail";
                  getExamScore();
                }

                Data.examData = res.data;

                if (Data.examData.tips) {
                  Data.heartContent = String(Data.examData.tips);
                }

                for (_i = 0, _Object$keys = Object.keys(Data.tipsData); _i < _Object$keys.length; _i++) {
                  v = _Object$keys[_i];

                  if (Data.tipsData[v].english != "allNumber") {
                    Data.tipsData[v].value = res.data[Data.tipsData[v].english] | 0;
                  } else {
                    questionArr = ["choiceNumber", "mutiChoiceNumber", "tfNumber", "gapNumber"];
                    number = 0;

                    for (_i2 = 0, _questionArr = questionArr; _i2 < _questionArr.length; _i2++) {
                      vv = _questionArr[_i2];
                      number += Number(res.data[vv] || 0);
                    }

                    Data.tipsData[v].value = number;
                  }
                }

                sessionStorage.setItem('duration', String(Data.examData.duration)); // store.commit('annualCheck/examTimeChange', Data.examData.duration)

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function getExamDetail() {
        return _ref3.apply(this, arguments);
      };
    }(); // 判断是否到考试时间


    var isExamStart = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var res;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["IntegratedExamHistoryIsStart"]({
                  historyId: route.query.historyId
                });

              case 2:
                res = _context4.sent;

                if (!(res.msg == "可以进行考试")) {
                  _context4.next = 7;
                  break;
                }

                return _context4.abrupt("return", true);

              case 7:
                ElMessage.error("".concat(res.msg));
                return _context4.abrupt("return", false);

              case 9:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function isExamStart() {
        return _ref4.apply(this, arguments);
      };
    }(); // 交卷之后获取考试成绩并查看详情


    var getExamScore = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var res, _i3, _Object$keys2, v;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["IntegratedExamHistory"]({
                  historyId: route.query.historyId
                });

              case 2:
                res = _context5.sent;

                if (res.code == 0) {
                  for (_i3 = 0, _Object$keys2 = Object.keys(Data.scoreData); _i3 < _Object$keys2.length; _i3++) {
                    v = _Object$keys2[_i3];

                    if (v == "1") {
                      Data.scoreData[v].value = Number(res.data.score) >= Number(res.data.passScore) ? "及格" : "不及格";
                    } else {
                      Data.scoreData[v].value = res.data[Data.scoreData[v].english];
                    }
                  }
                }

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      return function getExamScore() {
        return _ref5.apply(this, arguments);
      };
    }(); //点击取消


    var handleCancel = function handleCancel(num) {
      if (num == 0) {
        Data.dialogHeart = false;
        Data.heartContent = '';
      } else {
        Data.dialogHeart = true;
        Data.heartContent = String(Data.examData.tips);
      }
    };

    return {
      Data: Data,
      handleButton: handleButton,
      isExamStart: isExamStart,
      getExamDetail: getExamDetail,
      getExamScore: getExamScore,
      handleAddHeart: handleAddHeart,
      HeartFormRef: HeartFormRef,
      contentPass: contentPass,
      handleCancel: handleCancel,
      ranking: ranking
    };
  }
});